<template>
  <div>
    <div class="form-wrap">
      <div class="form-list py-2">
        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.family_name.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['5_2'][1]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="Yamada" v-model="input.family_name" @change="$v.input.family_name.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.family_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_2'][1]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.given_name.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['5_2'][2]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="Taro" v-model="input.given_name" @change="$v.input.given_name.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.given_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_2'][2]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <div class="form-group row" :class="{'has-danger': $v.input.address_1.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['5_2'][3]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="301" v-model="input.address_1" @change="$v.input.address_1.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">AAA
            <input-feedback :validate-for-input="$v.input.address_1" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_2'][3]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['5_2'][4]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="3-3-3" v-model="input.address_2" @change="$v.input.address_2.$touch()">
          </div>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <div class="form-group row" :class="{'has-danger': $v.input.city.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['5_2'][5]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="Kobe" v-model="input.city" @change="$v.input.city.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.city" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_2'][4]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <div class="form-group row" :class="{'has-danger': $v.input.prefecture.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['5_2'][6]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="Hyogo" v-model="input.prefecture" @change="$v.input.prefecture.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.prefecture" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_2'][5]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <div class="form-group row" :class="{'has-danger': $v.input.zip_code.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['5_2'][7]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="6520043" v-model="input.zip_code" @change="$v.input.zip_code.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.zip_code" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_2'][6]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <div class="form-group row" :class="{'has-danger': $v.input.country_name.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['5_2'][8]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="Japan" v-model="input.country_name" @change="$v.input.country_name.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.country_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_2'][8]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <div class="form-group row" :class="{'has-danger': $v.input.phone_nunber.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['5_2'][9]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="08012345678" v-model="input.phone_nunber" @change="$v.input.phone_nunber.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.phone_nunber" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_2'][9]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <div class="form-group row" :class="{'has-danger': $v.input.email.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['5_2'][10]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="abc@abc.com" v-model="input.email" @change="$v.input.email.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.email" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_2'][11]"/></input-feedback>
            <input-feedback :validate-for-input="$v.input.email" type="email"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_2'][12]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['5_2'][11]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="password" value="" placeholder="******" v-model="input.password" @change="$v.input.password.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.password" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_2'][13]"/></input-feedback>
            <input-feedback :validate-for-input="$v.input.password" type="email"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_2'][14]"/></input-feedback>
            <input-feedback :validate-for-input="$v.input.password" type="minLength"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_2'][15]"/></input-feedback>
          </p>
        </div>
        <!-- フォーム送信UI -->
        <div class="row text-center">
          <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
            <div class="my-2">
              <button type="button" class="btn w-100 btn-lg btn-warning" @click="tryForm">
                <trans-text i18nKey="ui['5_2'][12]"/>
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

  import {dd,store,app} from 'systems/imports'

  import FormPartialBase from 'extends/FormPartialBase.vue'
  import {numeric,required,email,minLength,alphaNum,sameAs} from 'systems/validators'

  /** @see page_subPages_MyPage_OrdererInfo */
  export default {
    extends:FormPartialBase,
    components: {
    },
    props:["orderer","user"],
    data () {

      return {
        input: {
          family_name: "",
          given_name: "",
          address_1:"",
          address_2:"",
          city:"",
          prefecture:"",
          zip_code:"",
          phone_nunber:"",
          country_name:"",
          email: "",
          password: "",
        }
      }
    },
    watch:{
      orderer(){
          Object.assign(this.input, (this.orderer? this.orderer : {}))
          this.input = this.orderer
      },
      "input.zip_code"(newVal, oldVal){
        let val = String(newVal).replace(/[０-９]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        }).replace(/[^\d]/g, '');
        this.input.zip_code =  val
      },
      "input.phone_nunber"(newVal, oldVal){
        let val = String(newVal).replace(/[０-９]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        }).replace(/[^\d]/g, '');
        this.input.phone_nunber =  val
      },
    },
    validations: {
      input: {
        family_name: {
          required
        },
        given_name: {
          required
        },
        address_1: {
          required
        },
        address_2: {
        },
        city: {
          required
        },
        prefecture: {
          required
        },
        zip_code: {
          required
        },
        phone_nunber: {
          required,
        },
        country_name: {
          required
        },
        email: {
          required,
          email,
        },
        password:{
          minLength: minLength(8),
        }
      },
    },
    methods:{
      tryForm(e){/**/
        //バリデーション
        if(this.$v.input.$invalid){
          this.$v.input.$touch()
          return
        }
        this.$emit('tryForm', this.input)
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// PageForm.vue?5a7dd82c